import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialog, MdDialogRef } from '@angular/material';

import { ConstantsService } from 'app/services/constants-service';
import { FormErrors} from 'app/shared/validators/generic-validators';
import { GenericSearchDetails } from 'app/shared/models/generic-search-details.model';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';

import { BankAccount } from 'app/shared/models/bank-account.model';

import { FinanceService } from 'app/finance/finance.service';

@Component({
    selector: 'sync-citco',
    templateUrl: './sync-citco.component.html',
})

/**
 * Component to initiate synchronization with CITCO.
 */
export class SyncCitcoComponent implements OnInit {
    syncingCitco: boolean;
    syncCitcoForm: FormGroup;

    clientId: number;
    clientAccounts: BankAccount[];
    username: string;
    password: string;

    integrationClientSearchURI = ConstantsService.CLIENT_SEARCH;
    searchPlaceholder = MessageService.CLIENT_NAME_SEARCH_PLACEHOLDER;

    formErrors = {
        'username': '',
        'password': '',
        'clientName': '',
        'clientAccountNo': '',
    };

    validationMessages = {
        'username': {
            'required': 'Required field value.',
        },
        'password': {
            'required': 'Required field value.',
        },
        'clientName': {
            'required': 'Required field value.',
            'invalid': 'Invalid client name.',
        },
        'clientAccountNo': {
            'required': 'Required field value.',
        },
    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private formBuilder: FormBuilder,
        private financeService: FinanceService,
        private snackBarService: SnackBarService) { }

    createForm() {
        this.syncCitcoForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            clientAccountNo: [],
            clientName: [],
        });
        this.syncCitcoForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    onSubmit({ value, valid }) {
        const params = {
            username: value.username,
            password: value.password,
            clientId: this.clientId,
            accountNo: value.clientAccountNo,
        };
        this.syncingCitco = true;
        this.financeService.initiateSyncCitco(params)
            .subscribe(response => {
                this.syncingCitco = false;
                if (response.flagResult) {
                    this.dialogRef.close(response.arrResult);
                }
                this.callSnackBarService(response,
                    MessageService.SYNC_CITCO_SUCCESS,
                    MessageService.SYNC_CITCO_FAILURE);
                },
                err => {
                this.syncingCitco = false;
                this.callSnackBarService(err,
                    MessageService.SYNC_CITCO_SUCCESS,
                    MessageService.SYNC_CITCO_FAILURE);
                }
            );
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }

    onValueChanged(data?: any) {
        if (!this.syncCitcoForm) {
            return;
        }
        FormErrors('syncCitcoForm', this);
    }

    ngOnInit() {
        this.createForm();
    }

    onClientNameChanged(value){
        this.clientAccounts = [];
        this.syncCitcoForm.controls['clientAccountNo'].setValue(null);
        let nameControl = this.syncCitcoForm.controls['clientName'];
        if (!!value && typeof value === 'string' && value != nameControl.value && nameControl.touched) {
            this.clientId = null;
            nameControl.setErrors({ 'invalid': this.validationMessages['clientName']['invalid']});
            nameControl.markAsTouched();
        } else if (!value) {
            nameControl.markAsUntouched();
        }
    }

    onClientSelectionEvent(searchDetails: GenericSearchDetails) {
        this.clientId = searchDetails.clientId;
        this.syncCitcoForm.controls['clientName'].setValue(searchDetails.clientName);
        this.syncCitcoForm.controls['clientName'].markAsTouched();
        this.financeService.getBankAccountsForEntity(searchDetails.entityId)
            .subscribe(response => {
                if (response.message) {
                   this.callSnackBarService(response, '', '');
                } else {
                    this.clientAccounts = response;
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/finance/payments/synccitco/sync-citco.component.ts